module.exports = __webpack_public_path__ + "img/fondo-full-javier.ae78e494.jpg";